$(function () {
    var form = $("#loginWrap");
    var firstError = form.find(".input-validation-error:first"), firstEmpty;
    if (firstError.length > 0) {
        firstError[0].focus();
    } else if ((firstEmpty = form.find(":input:visible").filter(function () { return this.value == ''; }).first()).length > 0) {
        firstEmpty[0].focus();
    } else {
        form.find(":input:visible:first")[0].focus();
    }

    form.submit(function () {
        localStorage.clear();
        sessionStorage.clear();
        $(this).find('#loginMessage').html("authenticating...");
        $(this).find('#loginButton').attr('disabled', 'disabled');
        spinner.show();
    });

    if (!!location.hash) {
        form.attr("action", form.attr("action") + location.hash);
    }

    // Setup Forgot Password modal
    var modal = $("#forgotPasswordModal").modalForm({ header: "Forgot Password" });
    modal.onshow = function () {
        var first = modal.$el.find("input:text").first();
        first.val('');
        first.focus();
    }
    $("#forgotPassword").click(function () {
        modal.toggle();
    });
    var passwordForm = $("#forgotPasswordForm");
    var message = modal.$el.find(".message");
    message.hide();
    var throbber = modal.content.throbber({ size: 12 });
    passwordForm.submit(function (e) {
        e.preventDefault();
        throbber.start();
        var data = $(this).serialize();
        message.hide();
        $.post($(this).attr("action"), data, function (result) {
            if (result.success) {
                modal.hide();
                modalAlert({ message: result.message });
            } else {
                throbber.stop();
                message.text(result.message);
                message.removeClass("success-message");
                message.show();
            }
        }).complete(function () {
            throbber.stop();
        });
    });

    var spinner = $(".spinnerMask");
    spinner.hide();

    $('#da-slider').cslider({
        autoplay: true,
        interval: 9000
    });



    appReady(true);
});